import modal from './modal';

export default (editor, opts = {}) => {
    const $ = editor.$;
    const pfx = editor.getConfig().stylePrefix;
    const mdlClass = `${pfx}mdl-dialog-sm`;
    let mdlEl;

    mdlEl = $(`#${pfx}mdl-preview`).length ? $(`#${pfx}mdl-preview`) :
        $(`<div id="${pfx}mdl-preview">
            <div style="font-size:15px;">What would you like to preview?</div><br>
            <button class="${pfx}btn-prim">Current Draft</button>
            <button class="${pfx}btn-prim">Published Site</button>
        </div>`);

    if (!$(`#${pfx}mdl-preview`).length) {
        const btns = mdlEl.find(`.${pfx}btn-prim`);
        btns.get(0).addEventListener('click', () => {
            editor.runCommand('preview');
            editor.Modal.close();
        });
        btns.get(1).addEventListener('click', () => {
            opts.previewPublished && opts.previewPublished();
        });
    }

    modal(editor, mdlClass, 'Preview', mdlEl.get(0));
};